import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px;
  background: linear-gradient(145deg, #ffffff, #f5f6fa);
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.05),
              -2px -2px 5px rgba(255, 255, 255, 0.8);
`;

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  margin-right: 12px;
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 24px;
  
  &:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }
`;

const Input = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  
  &:checked + ${Slider} {
    background-color: #4a6fa1;
  }
  
  &:checked + ${Slider}:before {
    transform: translateX(26px);
  }
  
  &:focus + ${Slider} {
    box-shadow: 0 0 1px #4a6fa1;
  }
`;

const Label = styled.span`
  font-size: 14px;
  color: #4a6fa1;
  user-select: none;
`;

const SharedDataToggle = ({ includeSharedData, onToggle }) => {
  const { t, i18n } = useTranslation();

  // Отладочный вывод для проверки состояния и локализации
  useEffect(() => {
    console.log('[SharedDataToggle] Current state:', includeSharedData);
    console.log('[SharedDataToggle] Current language:', i18n.language);
  }, [includeSharedData, i18n]);

  // Обработчик переключения состояния
  const handleToggle = (e) => {
    const newValue = e.target.checked;
    console.log("[SharedDataToggle] Toggle clicked, new state:", newValue);
    
    // Вызываем родительский обработчик с событием, содержащим checked
    onToggle(e);
    
    // Сохраняем состояние в localStorage
    localStorage.setItem('includeSharedData', newValue);
  };

  return (
    <ToggleContainer>
      <Switch>
        <Input 
          type="checkbox" 
          checked={includeSharedData} 
          onChange={handleToggle}
        />
        <Slider />
      </Switch>
      <Label>
        {includeSharedData 
          ? t('include_shared_data', 'Общие данные') 
          : t('personal_data_only', 'Только личные данные')}
      </Label>
    </ToggleContainer>
  );
};

export default SharedDataToggle;